import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/core/controls/base.component';
import { GoodsModel } from 'src/models/goods.model';
import { GoodsGroupModel } from 'src/models/goodsgroup.model';
import { TableModel } from 'src/models/table.model';
import { ShareDataService } from 'src/providers/sharedata.service';
import { takeUntil } from 'rxjs/operators';
import { UploadDownloadService } from '../file-upload/upload-download.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ProgressStatus, ProgressStatusEnum } from 'src/models/progress-status.model';
import { HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-goods',
  templateUrl: './goods.component.html',
  styleUrls: ['./goods.component.scss']
})
export class GoodsComponent extends BaseComponent implements OnInit {

  @Input() public disabled: boolean;
  @Output() public uploadStatus: EventEmitter<ProgressStatus>;
  @ViewChild('inputFile') inputFile: ElementRef;
  @ViewChild("myFoodElem") myFoodElem: ElementRef;
  @ViewChild("myFoodtypeElem") myFoodtypeElem: ElementRef;
  goodsGroup: GoodsGroupModel[];
  selectedGoodsGroup: GoodsGroupModel;
  firstGoodsGroup: GoodsGroupModel;
  selectedIndex = 0;
  selectedGoodsGroupIndex = 0;
  selectedgoods: GoodsModel[]; timeStamp: any; linkPicture: string;
    DateNow: string;

  constructor(public share: ShareDataService, public uploadService: UploadDownloadService,
    private sanitizer: DomSanitizer) {
    super();
    this.uploadStatus = new EventEmitter<ProgressStatus>();
   }

  ngOnInit(): void {
    this.goodsGroupList(); this.date();
  }

  goodsGroupList() {
    if (!(this.share.goodsGroup)) {
      this.goodsGroup = null;
      this.api.getEntity<GoodsGroupModel[]>('GoodsGroupList')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(res => {
          this.goodsGroup = res;
          this.share.goodsGroup = JSON.parse(JSON.stringify(this.goodsGroup));
          this.goodsGroup.forEach(e => {
            e.foodtypeUrl = '../../../assets/imgs/foodtype/' + e.code + '.png';
            e.goods.forEach(ele => {
              ele.goodsUrl = '../../../assets/imgs/' + ele.code + '.jpg';
            });
          });
        });
    } else {
      this.goodsGroup = JSON.parse(JSON.stringify(this.share.goodsGroup));
      this.selectedgoods = null;
      this.goodsGroup.forEach(e => {
        e.foodtypeUrl = '../../../assets/imgs/foodtype/' + e.code + '.png';
        e.goods.forEach(ele => {
          ele.goodsUrl = '../../../assets/imgs/' + ele.code + '.jpg';
        });
      });
    }
    if (!(this.share.orderTable)) {
      this.getTableOrder();
    }
  }

  getTableOrder() {
    if (this.share.tableId !== '0') {
      this.api.getFilterEntity<TableModel>('GetTableOrder', Number(this.share.tableId))
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(res => {
          this.share.orderTable = res;
        });
    }
    else {
      this.share.orderTable = new TableModel;
      this.share.orderTable.tableName = 'حضوری';
      this.share.orderTable.tableId = 0;
    }
  }

  public upload(event, action, goods) {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadService.setPath(this.sanitizer.bypassSecurityTrustUrl(file));
      this.uploadStatus.emit( {status: ProgressStatusEnum.START});
      this.uploadService.uploadFile(file, action, goods).subscribe(
        data => {
          if (data) {
            switch (data.type) {
              case HttpEventType.UploadProgress:
                this.uploadStatus.emit( {status: ProgressStatusEnum.IN_PROGRESS, percentage: Math.round((data.loaded / data.total) * 100)});
                break;
              case HttpEventType.Response:
                this.inputFile.nativeElement.value = '';
                this.uploadStatus.emit( {status: ProgressStatusEnum.COMPLETE});
                this.router.navigate(['/portal/goods']);
                this.share.reloadCurrentRoute();
                break;
            }
          }
        },
        error => {
          this.inputFile.nativeElement.value = '';
          this.uploadStatus.emit( {status: ProgressStatusEnum.ERROR});
        }
      );
    }
  }

  getLinkPicture(ftu: GoodsGroupModel) { //foodTypeUrl
    if(this.timeStamp) {
      return this.linkPicture + '?' + this.timeStamp;
    }
    console.log(ftu.foodtypeUrl);
    return this.linkPicture;
  }
  public setLinkPicture(url: string) {
    this.linkPicture = url;
    this.timeStamp = (new Date()).getTime();
  }

  reloadCurrentRoute() {
    let currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        this.router.navigate([currentUrl]);
    });
  }

  date(): void {
    this.DateNow = `?${Date.now()}`;
  }
}
